import React from 'react'
import { ImageBaseUrl } from '../../HTTPS/Api';
import { Avatar, Badge } from '@mui/material';
import { stringAvatar } from '../../hooks/convertAvatarInitital';
import PatientName from '../PatientName';
import { CachedUserDetails } from '../../utils/UserData';

function CommunityCard(props) {
  const { id, name, relationship, image, mobile, patient, newMessageCount } = props.content;

  return (
    <>
      <div className="shadow-[0px_0px_0px_1px_rgba(0,0,0,0.06),0px_1px_1px_-0.5px_rgba(0,0,0,0.06),0px_3px_3px_-1.5px_rgba(0,0,0,0.06),_0px_6px_6px_-3px_rgba(0,0,0,0.06),0px_12px_12px_-6px_rgba(0,0,0,0.06),0px_24px_24px_-12px_rgba(0,0,0,0.06)] flex justify-between items-center p-3 sm:p-5 rounded-xl bg-[#ecf1f4] my-5">
        {/* Logo  */}
        <div className="flex items-center gap-2 sm:gap-5">
          <button className="flex items-center gap-4">
            <span className="">
              <Badge
                overlap="circular"
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                badgeContent={
                  <>
                    {newMessageCount ? (
                      <div className="bg-[#ed7117] rounded-full text-white px-1.5 py-1 border-4 border-gray-100">
                        {newMessageCount}
                      </div>
                    ) : null}
                  </>
                }
              >
                <Avatar
                  src={image ? `${ImageBaseUrl}/${image}` : ""}
                  {...stringAvatar(name)}
                  className="h-10 w-10 sm:!h-16 sm:!w-16 rounded-full uppercase !text-base xs:!text-lg"
                />
              </Badge>
            </span>
          </button>
          {/* Content  */}
          <div className="">
            <h2 className="text-[0.8rem] xxs:text-sm sm:text-xl font-bold">
              {name}
            </h2>
            <h4 className="text-[#8C8CA1] text-[0.7rem] xxs:text-sm font-semibold">
              {relationship && ["Others", "Other"].includes(relationship) ? (
                relationship
              ) : (
                <>
                  <PatientName patient={patient} />
                  's {relationship}
                </>
              )}
            </h4>
          </div>
        </div>
        {/* Icons  */}

        {CachedUserDetails()?.id !== id && (
          <div className="flex gap-3 items-center">
            <div className="bg-[#ED7117] p-2 px-3.5 rounded-full ">
              <a href={`tel:${mobile}`}>
                <svg
                  width="16"
                  height="28"
                  viewBox="0 0 16 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.0841 2.71871V1.69267C13.0841 1.12496 12.6301 0.666626 12.0678 0.666626C11.5055 0.666626 11.0516 1.12496 11.0516 1.69267V2.71871H2.92164C1.79707 2.71871 0.88916 3.63538 0.88916 4.77079V25.2812C0.88916 26.4166 1.79707 27.3333 2.92164 27.3333H13.0789C14.2035 27.3333 15.1114 26.4166 15.1114 25.2812V4.77079C15.1114 3.63538 14.2035 2.71871 13.0841 2.71871ZM4.95413 25.2812H2.92164V23.2291H4.95413V25.2812ZM4.95413 21.177H2.92164V19.125H4.95413V21.177ZM4.95413 17.0781H2.92164V15.026H4.95413V17.0781ZM9.01909 25.2812H6.98661V23.2291H9.01909V25.2812ZM9.01909 21.177H6.98661V19.125H9.01909V21.177ZM9.01909 17.0781H6.98661V15.026H9.01909V17.0781ZM13.0841 25.2812H11.0516V23.2291H13.0841V25.2812ZM13.0841 21.177H11.0516V19.125H13.0841V21.177ZM13.0841 17.0781H11.0516V15.026H13.0841V17.0781ZM13.0841 11.9479C13.0841 12.5156 12.6301 12.9739 12.0678 12.9739H3.93788C3.3756 12.9739 2.92164 12.5156 2.92164 11.9479V5.79683C2.92164 5.22913 3.3756 4.77079 3.93788 4.77079H12.0627C12.6249 4.77079 13.0789 5.22913 13.0789 5.79683V11.9479H13.0841Z"
                    fill="#FAFCFE"
                  />
                </svg>
              </a>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default CommunityCard